module.exports = __webpack_public_path__ + "img/iea.5f3a6e0f.png";